import { DetailedProject } from '@/domain/project/types';
import { cn } from '@/lib/utils';

enum VideoSource {
  Youtube = 'youtube',
  Vimeo = 'vimeo',
}

interface VideoPlayerProps {
  video: Exclude<DetailedProject['video'], undefined>;
  className?: string;
}

const VideoPlayer = ({ video, className }: VideoPlayerProps) => {
  const url =
    video.source === VideoSource.Vimeo
      ? `https://player.vimeo.com/video/${video.id}`
      : `https://www.youtube.com/embed/${video.id}`;

  return (
    <iframe
      allowFullScreen
      title={video.poster}
      id={video.id}
      className={cn('aspect-video w-full rounded-2xl ', className)}
      src={url}
    />
  );
};

export default VideoPlayer;
